import { css } from '@/styled-system/css';

export const systemMessageBubbleStyles = css.raw({
  borderBottomLeftRadius: '100',
  backgroundColor: 'bg.neutral',
  border: '1px solid',
  borderColor: 'border.muted',
  maxWidth: '448px',
  padding: 0,
});
